class WishlistDrawer extends Drawer {
  constructor() {
    super();

    this.inputs = this.querySelectorAll(".field__input");
    this.submitButton = this.querySelector(".js-submit");

    this.addListeners();
  }

  addListeners() {
    this.inputs.forEach(input => {
      if (input.tagName === "TEXTAREA") return;

      input.addEventListener("change", this.onInputChange.bind(this));
    });

    this.submitButton?.addEventListener("click", this.onSubmit.bind(this));
  }

  onInputChange(event) {
    const input = event.target;

    this.checkForErrors(input)
  }

  onSubmit(event) {
    event.preventDefault();

    const isValid = this.isValidSubmission();

    if (!isValid) return this.inputs.forEach(input => this.checkForErrors(input));

    publish(PUB_SUB_EVENTS.wishlistShareSubmit, this.getFormData());

    this.close();
  }

  getFormData() {
    return Array.from(this.inputs).reduce((acc, input) => {
      acc[input.name] = input.value.trim();

      return acc;
    }, {});
  }

  isValidSubmission() {
    return Array.from(this.inputs).every(input => {
      if (input.tagName === "TEXTAREA") return true;

      return input.value.trim().length > 0;
    });
  }

  checkForErrors(input) {
    const field = input.closest(".field");
    const value = input.value.trim();

    return value.length > 0
      ? field.classList.remove("field--with-error")
      : field.classList.add("field--with-error");
  }

  close() {
    this.inputs.forEach(input => {
      const field = input.closest(".field");

      input.value = "";

      field.classList.remove("field--with-error");
    });

    super.close();
  }
}

customElements.define("wishlist-drawer", WishlistDrawer);